import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Box, Chip, Typography } from "@mui/material";
import { SUGGESTION_KEYS } from "src/_modules/AiSupportChat/constants";

/**
 * "Common questions" (plan §3.5): one chip per `SUGGESTION_KEYS` entry.
 * Clicking hands the question, in the UI language, to `onSelect`, which
 * starts a new conversation and sends it at once (AiChatPanel). Disabled
 * while an answer streams (C17).
 *
 * @param {object} props
 * @param {(text: string) => void} props.onSelect
 * @param {boolean} [props.disabled]
 */
export default function SuggestionChips({ onSelect, disabled = false }) {
  const { t } = useTranslation("aiSupport");
  const titleId = useId();

  return (
    <Box>
      <Typography
        id={titleId}
        component="h3"
        variant="subtitle2"
        sx={{ fontWeight: 600, mb: 1 }}
      >
        {t("home.suggestionsTitle")}
      </Typography>
      <Box
        role="group"
        aria-labelledby={titleId}
        sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
      >
        {SUGGESTION_KEYS.map((key) => {
          const text = t(key);
          return (
            <Chip
              key={key}
              label={text}
              variant="outlined"
              color="primary"
              disabled={disabled}
              onClick={() => onSelect(text)}
              // Wrap long questions instead of cutting them at 360 px
              sx={{
                height: "auto",
                maxWidth: "100%",
                "& .MuiChip-label": { whiteSpace: "normal", py: 0.75 },
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
